import React from "react";
import {TEXT_TYPES} from "../../../constants/APP_CONSTANTS";
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import union from "lodash/union";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import ReactTable from "react-table";
import moment from "moment";
import ActionCard from "../../widgets/ActionCard/ActionCard";

export default class MetadataUpdateStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            metadataUpdateBatches: [],
            pageSize: 25,
            pageNumber: null,
            totalItems: 0,
            hasMore: true,
            selectedBatchId: null,
            statusesList: {},
            activeActionCards: [],
            isLoading: true
        };
    }

    componentDidMount() {
        this.loadMore();
    }

    loadMore = () => {
        if (!this.state.hasMore) {
            return;
        }

        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getMetadataUpdateBatches,
            {
                pageSize: this.state.pageSize,
                pageNumber:
                    this.state.pageNumber === null
                        ? 0
                        : this.state.pageNumber + 1
            }
        );
        AxiosClient.get(url).then(response => {
            const results = response.data;

            this.setState(prevState => ({
                metadataUpdateBatches: union([
                    ...prevState.metadataUpdateBatches,
                    ...results.content
                ], 'batchId'),
                pageNumber: results.number,
                totalItems: results.totalElements,
                hasMore: !results.last,
                isLoading: false
            }));
        });
    };

    hasMore = () => {
        this.setState({
            hasMore: false
        });
    };
    toggleActionCard = index => {
        this.setState(prevState => {
            const prevActive = prevState.activeActionCards;
            return {
                activeActionCards: prevActive.includes(index)
                    ? prevActive.filter(active => active !== index)
                    : prevActive.concat([index])
            };
        });
    };

    generateStatusesList = selectedBatchId => {
        const selectedBatch = this.state.metadataUpdateBatches.find(
            item => item.batchId === selectedBatchId
        );

        const statusesList = {
            "FAILED" : [],
            "PENDING" : [],
            "COMPLETED" : [],
            "DOES_NOT_EXIST" : [],

        };
        selectedBatch.metadataUpdateStatus
            .map(item => {
                if (item.metadataUpdateStatus? item.metadataUpdateStatus: item.updateStatus === "PROCESSING") {
                    item.metadataUpdateStatus? item.metadataUpdateStatus: item.updateStatus = "PENDING";
                }
                return item;
            })
            .forEach(statusItem => {
                statusesList[statusItem.metadataUpdateStatus? statusItem.metadataUpdateStatus: statusItem.updateStatus]
                    ? statusesList[statusItem.metadataUpdateStatus? statusItem.metadataUpdateStatus: statusItem.updateStatus].push(statusItem)
                    : (statusesList[statusItem.metadataUpdateStatus? statusItem.metadataUpdateStatus: statusItem.updateStatus] = [statusItem]);
            });

        this.setState({
            statusesList,
            selectedBatchId,
            activeActionCards: Object.keys(statusesList).map(
                (_, index) => index
            )
        });
    };

    renderActionCards = () => (
        <div>
            {Object.entries(this.state.statusesList).map(
                ([statusName, statusItems], index) => ((statusItems.length !== 0)
                    && <ActionCard
                        className={`action-card-${statusName}`}
                        key={index}
                        headerOnClick={() => this.toggleActionCard(index)}
                        controlsLeft={
                            <div className={`pe-label pe-bold card-title`}>
                                {statusName}
                            </div>
                        }
                        controlsRight={
                            <span className={`badge px-2`}>
                                {statusItems.length}
                            </span>
                        }
                    >
                        {this.state.activeActionCards.includes(index) && (
                            <div>
                                <table className="pe-table mb-0">
                                    <thead>
                                        <tr>
                                            {statusName !== "FAILED" && (
                                                <th scope="col">
                                                    Status ID
                                                </th>
                                            )}
                                            <th scope="col">Resource Id</th>
                                            <th scope="col">Resource Title</th>
                                            <th scope="col">ISBN</th>
                                            {statusName === "FAILED" && (
                                                <th scope="col">Comment</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {statusItems.map((item, id) => (
                                            <tr key={id}>
                                                {statusName !== "FAILED" && (
                                                    <th scope="row">
                                                        {item.id}
                                                    </th>
                                                )}
                                                <td>{item.resourceId}</td>
                                                <td>{item.title}</td>
                                                <td>{item.isbn}</td>
                                                {statusName === "FAILED" && (
                                                    <td>{item.comment}</td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </ActionCard>
                )
            )}
        </div>
    );

    render() {
        const columns = [
            {
                Header: "Batch ID",
                accessor: "batchId",
                sortable: true,
            },
            {
                Header: "Resource Count",
                accessor: "resourceCount",
                sortable: true
            },
            {
                Header: "Last Updated Date",
                id: "creationDate",
                width: 150,
                accessor: d =>
                    moment(d.creationDate)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
                sortable: true
            }
        ];

        return (
            <div className="content-home-page metadata-update-status">
                <div>
                    <label className="pe-page-title--small">
                        {TEXT_TYPES.METADATA_UPDATE_STATUS}
                    </label>
                    <hr />
                </div> {this.state.isLoading && <LoadingIndicator/>}
                <div className="pe-row">
                    <div className="pe-col-4 pt-4">
                         {this.state.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        this.state.metadataUpdateBatches
                                            .length
                                    }
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    loader={<LoadingIndicator />}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight"
                                            data={
                                                this.state
                                                    .metadataUpdateBatches
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.state.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            resizable={false}
                                            noDataText="No Curated Collection Batches found"
                                            getTrProps={(_, rowInfo) => {
                                                const selectedBatch = rowInfo.original.batchId;
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: () => this.generateStatusesList(selectedBatch)
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                    <div className="pe-col-8">{this.renderActionCards()}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/MetadataUpdateStatus.js